import api from "!../../../../../../releases/fbb8d5da90026171ba90bb4cf2f6f6031f23f80e/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../releases/fbb8d5da90026171ba90bb4cf2f6f6031f23f80e/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[1]!../../../../../../releases/fbb8d5da90026171ba90bb4cf2f6f6031f23f80e/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[2]!../../../../../../releases/fbb8d5da90026171ba90bb4cf2f6f6031f23f80e/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[3]!./admin.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};